import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AccessDeniedCont,
  AccessDeniedHeading,
  AccessDeniedStatus,
  AccessDeniedText,
  ContentCont,
  LogoIcon,
} from './403.styles';

export interface IPage403 {
  message?: ReactNode | string;
  status: number;
}

const Page403: FC<IPage403> = ({ message = undefined, status }) => {
  const { t } = useTranslation();

  return (
    <AccessDeniedCont>
      <ContentCont>
        <LogoIcon role="img" title="Logo" />
        <AccessDeniedStatus as="h1">{status}</AccessDeniedStatus>
        <AccessDeniedHeading as="h2">{t('accessDenied.heading')}</AccessDeniedHeading>
        {message ? <AccessDeniedText as="p">{message}</AccessDeniedText> : null}
      </ContentCont>
    </AccessDeniedCont>
  );
};

export default Page403;
